module.exports = __webpack_public_path__ + "static/media/cocktail.60b3074a.png";